module.exports = __webpack_public_path__ + "img/606.8447d102.jpg";